import { Hidden } from '@mui/material'
import cn from 'classnames'
import moment from 'moment'
import Image from 'next/image'
import { useRouter } from 'next/router'
import React, { memo, useEffect, useState } from 'react'
import icGraveyard from 'src/assets/ic-graveyard.png'
import { ClaimYourListing } from 'src/components/ClaimYourListing/ClaimYourListing'
import { EditListingButton } from 'src/components/EditListingButton/EditListingButton'
import CompareButton from 'src/components/global/CompareButton'
import { PortfolioPickerOption } from 'src/components/global/CreateNewPortfolioModal'
import { FollowButton } from 'src/components/global/FollowButton'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import VendorLogo from 'src/components/global/VendorLogo/VendorLogo'
// import { SolutionHeaderReviewStar } from 'src/components/SolutionHeaderReviewStar/SolutionHeaderReviewStar'
import { ProductPageTab } from 'src/components/Tabs/ProductPageTab'
import { THEME } from 'src/config/config'
import { IEnum_Solution_Type, useSolutionVendorBySlugLazyQuery } from 'src/graphql/generated/hooks'
//import { IEnum_Solution_Item_Type, IEnum_Solution_Type } from 'src/graphql/generated/hooks'
import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'
import { useSolutionDetailFollow } from 'src/hooks/useSolutionDetailFollow'
import { DETAILS_TAB } from 'src/types'
// import { checkNotEmpty } from 'src/utils/checkNotEmpty'
import {
  isConsolidationProductSolution,
  isGraveyardProductSolution,
  SolutionDataFragment,
} from 'src/utils/SolutionDataFragment'

import { SolutionTitle } from '../SolutionTitle/SolutionTitle'

interface SolutionHeaderProps {
  className?: string
  solution: SolutionDataFragment
  tabIdx: number
  showVendorAnalysis: boolean
  showProductBriefing: boolean
  vendorUsers?: string[]
  onSelectTab: (tabIdx: number) => void
}

/**
 * Primary UI component for user interaction
 */
export const SolutionHeader: React.FC<SolutionHeaderProps> = memo(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ className, solution, tabIdx, showVendorAnalysis, showProductBriefing, vendorUsers = [], onSelectTab }) => {
    const solutionObject: any = solution
    const { session, status /* , isVendor */ } = useAuthenticated()
    const [loginUserId, setLoginUserId] = useState('')
    const [solutionVendorUsers, setSolutionVendorUsers] = useState<string[]>(vendorUsers)
    const displayName = solution?.displayName || ''
    const logo = useDefaultLogo(solution?.logo?.url)
    // const { title, byTitle } = getNameSegments(solution)
    const description = solution?.shortDescription || ''

    // const isEnhancedSolution = solution.attributes?.isEnhanced || false
    // const isPremiumSolution = solution.attributes?.isPremium || false

    const router = useRouter()
    const { query } = router
    let vendorAllUsers = []
    const [loadsolutionData, { data: solutionData }] = useSolutionVendorBySlugLazyQuery()
    useEffect(() => {
      if (!solutionData) {
        loadsolutionData({
          variables: {
            slug: solution?.slug || '',
          },
          fetchPolicy: 'no-cache',
        })
      }
    }, [solutionData, loadsolutionData, solution?.slug])

    useEffect(() => {
      if (solutionData && solutionData?.solutions && solutionData?.solutions?.length > 0) {
        vendorAllUsers = solutionData?.solutions?.[0]?.vendor?.users?.map((user: any) => {
          return user?.external_id || null
        }) as string[]
        setSolutionVendorUsers(vendorAllUsers)
      }
    }, [solutionData])
    useEffect(() => {
      if (
        session &&
        status === 'authenticated' &&
        session?.user?.idToken != '' &&
        session?.user?.id != '' &&
        loginUserId == ''
      ) {
        setLoginUserId(session?.user?.id)
      }
    }, [session])

    const isGraveyard = isGraveyardProductSolution(solution)
    const isConsolidation = isConsolidationProductSolution(solution)
    let publishedDate = ''
    if (isGraveyard) {
      const date = solution?.graveyardData?.date
      publishedDate = date ? moment(date).format('MMM DD, YYYY') : ''
    }
    let acquiredBy = false
    if (isConsolidation) {
      let name: any = solution?.productData?.name

      const buyerData: any = solution
      if (buyerData?.consolidationData?.buyer && buyerData?.consolidationData?.date) {
        name = buyerData?.consolidationData?.buyer
      }

      const date = solution?.consolidationData?.date
      publishedDate = date ? moment(date).format('MMM DD, YYYY') : ''
      publishedDate = `Acquired by ${name} on ${publishedDate}`
      if (solution?.consolidationData?.buyer && solution?.consolidationData) acquiredBy = true
    }

    let iltaSponsorshipLogo = ''
    if ((solution?.iltaSponsorships || []).length > 0) {
      iltaSponsorshipLogo = solution?.iltaSponsorships?.[0]?.logo?.url || ''
    }

    const solutionType = solution?.type || IEnum_Solution_Type.Product
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const solutionAttribute: any = solution
    const productType = solutionAttribute ? solutionAttribute?.productType?.toLowerCase() : ''

    const {
      itemFollowState,
      followingType,
      sharedPortfolioSolutionsForFollow,
      hasLoadedFollowSearch,
      portfolioPickerOptions,
      refreshSharedPortfolios,
    } = useSolutionDetailFollow(solution.documentId, router.isReady)

    const ActionButtons = (
      <>
        {productType != 'graveyard' &&
          (hasLoadedFollowSearch ? (
            <FollowButton
              className="md:ml-[20px] mr-2"
              solutionType={solution?.type}
              id={solution.documentId!}
              displayName={displayName}
              follow={itemFollowState}
              isFromVendorList={true}
              followTypeName={followingType || ''}
              sharedPortfolioId={undefined}
              portfolioPickerOptions={portfolioPickerOptions}
              sharedPortfolioSolutions={sharedPortfolioSolutionsForFollow}
              styleParameters="top-[42px]"
              onRefresh={refreshSharedPortfolios}
            />
          ) : (
            <FollowButton
              className="mr-2"
              solutionType={solution?.type}
              id={solution.documentId!}
              displayName={displayName}
              follow={false}
              isFromVendorList={true}
              followTypeName={'Follow'}
              sharedPortfolioId={undefined}
              portfolioPickerOptions={[] as PortfolioPickerOption[]}
              sharedPortfolioSolutions={[]}
              styleParameters={'top-[42px]'}
              onRefresh={refreshSharedPortfolios}
            />
          ))}
        <div className="flex box-border h-[42px] w-[112px] border-solid border-[1px] border-mist rounded-[25px] bg-white items-center justify-center">
          <CompareButton className="items-center" slug={solution?.slug || ''} solutionType={solutionType} />
        </div>
      </>
    )

    const showClaimYourListing =
      solutionObject?.productType !== 'graveyard' || solutionObject?.type === IEnum_Solution_Type.Product
    const randomNum = solution?.documentId ?? solution?.slug ?? Math.floor(Math.random() * 1000) // Generates a number between 0 and 999

    /* const vendorResourcesProductBriefing =
      solution?.attributes?.vendorResources?.filter((resource) => {
        if (!resource) return false

        if (resource.type === 'Content') {
          const documentType = resource.content?.documentType
          const contentAttributes = resource.content
          const publishedAt = contentAttributes?.publishedAt ?? null
          if (documentType === 'Product_Briefing' && publishedAt !== null) {
            return true
          }
        }

        if (resource.type === 'External') {
          const documentType = resource.external?.documentType
          if (documentType === 'Product_Briefing') {
            return true
          }
        }

        return false
      }) || []
    const showProductBriefingTab = vendorResourcesProductBriefing.length > 0 ? true : false

    let enableVendorAnalysisTab = false

    if (showVendorAnalysis) {
      if (status === 'unauthenticated' && !session?.user?.id) {
        enableVendorAnalysisTab = true
      } else if (status === 'authenticated' && session?.user?.id && !isVendor) {
        enableVendorAnalysisTab = true
      } else if (
        status === 'authenticated' &&
        session?.user?.id &&
        isVendor &&
        solutionVendorUsers?.length > 0 &&
        solutionVendorUsers?.includes(session?.user?.id as string)
      ) {
        enableVendorAnalysisTab = true
      }
    } */

    return (
      <div key={`${randomNum}-SolutionHeader`} className={cn(className, 'flex flex-row justify-center bg-clouds')}>
        <div className="flex flex-row w-full justify-center">
          <div className="flex flex-col pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full pt-2 mt-[0.9375rem]">
            <div className="flex items-start">
              <div className="flex-1 flex flex-col md:flex-row items-center md:items-start sm:grid-cols-2">
                <VendorLogo className="md:mr-[1.6875rem]" alt={displayName} src={logo} />
                <div className="self-center w-full">
                  <div className="flex flex-row w-full">
                    <div className="flex flex-col w-full">
                      <div className="flex md:flex-row flex-col w-full justify-between">
                        <div className="flex flex-col flex-1 items-center md:items-start">
                          <SolutionTitle solution={solution} />
                        </div>
                        <ThemeOnly theme="legaltech">
                          {query['viewType'] !== 'manage' && <Hidden mdDown>{ActionButtons}</Hidden>}
                          {query['viewType'] === 'manage' &&
                            loginUserId &&
                            loginUserId != '' &&
                            solutionVendorUsers?.length > 0 &&
                            solutionVendorUsers?.includes(loginUserId) && (
                              <EditListingButton
                                slug={solution?.slug || ''}
                                solutionType={solution?.type.toString().toLowerCase() || ''}
                              />
                            )}
                        </ThemeOnly>
                      </div>
                    </div>
                  </div>
                  {!!publishedDate &&
                    (isGraveyard ? (
                      <div className="flex flex-row mb-1.5 h-[20px] w-fit bg-burlyWood rounded-[3px] items-center pl-[5px] pr-[5px]">
                        <Image src={icGraveyard} alt="" width={20} height={15} />
                        <p className="pl-[5px] h-[20px] text-textdark font-primary text-[15px] font-bold leading-[18px]">
                          {publishedDate}
                        </p>
                      </div>
                    ) : acquiredBy ? (
                      <p className="h-[20px] text-textdark font-primary text-[15px] font-bold leading-[18px]">
                        {publishedDate}
                      </p>
                    ) : (
                      ''
                    ))}
                  <Hidden mdDown>
                    <h2
                      className={cn(
                        'flex-1 text-[1.125rem] font-primary font-regular text-darkgray md:mt-[0px] mt-[1.25rem]',
                        {
                          '!font-tertiary !font-regular text-[16px]': THEME === 'ilta',
                        },
                      )}
                    >
                      <div className="value-proposition">
                        <HtmlContentViewer
                          html={description}
                          contentClassName={cn({
                            '!font-tertiary !font-regular text-[16px]': THEME === 'ilta',
                          })}
                        />
                      </div>
                    </h2>
                    {showClaimYourListing && <ClaimYourListing solution={solution} />}
                  </Hidden>
                </div>
              </div>
              {iltaSponsorshipLogo && (
                <Hidden mdDown>
                  <Image
                    src={iltaSponsorshipLogo}
                    width={200}
                    height={200}
                    className="w-[150px] h-auto ml-[50px]"
                    alt={''}
                  />
                </Hidden>
              )}
            </div>
            <Hidden mdUp>
              <ThemeOnly theme="legaltech">
                <div className="w-full flex flex-row mt-[20px] mb-[20px]">{ActionButtons}</div>
              </ThemeOnly>

              <h2
                className={cn(
                  'flex-1 text-[1.125rem] font-primary font-regular text-darkgray md:mt-[0px] mt-[1.25rem]',
                  {
                    '!font-tertiary !font-regular text-[16px]': THEME === 'ilta',
                  },
                )}
              >
                <HtmlContentViewer
                  html={description}
                  contentClassName={cn({
                    '!font-tertiary !font-regular text-[16px]': THEME === 'ilta',
                  })}
                />
              </h2>
              {showClaimYourListing && <ClaimYourListing solution={solution} />}
            </Hidden>
            <div className="flex w-full mt-[3.75rem] h-[3.125rem]">
              <div className="inline-flex gap-[40px]">
                <ProductPageTab id={DETAILS_TAB} activeTab={tabIdx} className="" onSelectTab={onSelectTab}>
                  Details
                </ProductPageTab>

                {/* {(isEnhancedSolution || isPremiumSolution) &&
                  checkNotEmpty(solution.attributes?.vendorResources) &&
                  showProductBriefingTab && (
                    <ProductPageTab
                      key={`${randomNum}-${PRODUCT_BRIEFING_TAB}`}
                      id={PRODUCT_BRIEFING_TAB}
                      activeTab={tabIdx}
                      className=""
                      onSelectTab={onSelectTab}
                    >
                      Product Briefing
                    </ProductPageTab>
                  )}

                {(isEnhancedSolution || isPremiumSolution) && enableVendorAnalysisTab && (
                  <ThemeOnly theme="legaltech">
                    <ProductPageTab id={VENDOR_ANALYSIS_TAB} activeTab={tabIdx} className="" onSelectTab={onSelectTab}>
                      Vendor Analysis
                    </ProductPageTab>
                  </ThemeOnly>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  },
)
